import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getSignerDetailsAndSettings } from '../../redux/actions/SignerAction';
import Loading from '../Loader/Loader';
import '../../assets/style/BankIDConsent.css';
import BankIDlogoImage from '../../assets/images/BankIDlogoImage.svg';

const BankIDConsent = () => {
  const { t, i18n } = useTranslation('common');
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const { signerDetails, fetching } = useSelector((state) => ({
    signerDetails: state.sign.signerDetailsAndSettings,
    fetching: state.sign.fetching
  }));

  const [signerId, setSignerId] = useState('');

  useEffect(() => {
    const id = searchParams.get('id');

    if (id) {
      setSignerId(id);
      dispatch(getSignerDetailsAndSettings(id));
    }
  }, [searchParams, dispatch]);

  useEffect(() => {
    if (signerDetails?.data) {
      const languageCode = signerDetails.data.Settings?.LanguageCode;

      if (languageCode === 1033) {
        i18n.changeLanguage('en');
      } else if (languageCode === 1044) {
        i18n.changeLanguage('no');
      }
    }
  }, [signerDetails, i18n]);

  const handleContinue = () => {
    window.location.href = `/signerdetails?id=${signerId}`;
  };

  if (fetching) {
    return <Loading />;
  }

  return (
<div className="bankid-page">
  <div className="bankid-header">
    <img
      src={BankIDlogoImage}
      alt="BankID"
      className="bankid-logo"
    />
  </div>

  <div className="bankid-center bankid-layout">
    <div className="bankid-card">

      <div className="bankid-top-row">
        <span className="bankid-small-text">
          {t('esign.bankidUsingText')}
        </span>

      </div>


      <div className="bankid-info-box">
        <h2 className="bankid-info-title">
           {t('esign.bankidConsentMessage')}
        </h2>
      </div>

  

      <button
        className="bankid-primary-btn"
        onClick={handleContinue}
      >
        {t('esign.bankidContinueBtn')}
      </button>

      <button
        className="bankid-cancel-btn"
        onClick={() => window.close()}
      >
        {t('esign.bankidCancelBtn')}
      </button>

    </div>
  </div>
</div>
  );
};

export default BankIDConsent;